import React from "react";
import { Link } from "react-router-dom";
import "./footer.css";

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <Link to="/" className="footer-logo">
            celsius<span className="brand-dot">.</span>in
          </Link>
          <p className="footer-tagline">Customized industrial refrigeration.</p>
        </div>

        <nav className="footer-col" aria-label="Products">
          <span className="footer-col-title">Products</span>
          <Link to="/product/co2liquefaction">CO₂ Liquefaction</Link>
          <Link to="/product/heatpumps">Heat Pumps</Link>
          <Link to="/product/icemachines">Ice Machines</Link>
          <Link to="/product/processchillers">Process Chillers</Link>
          <Link to="/product/coldstores">Cold Stores</Link>
        </nav>

        <nav className="footer-col" aria-label="Company">
          <span className="footer-col-title">Company</span>
          <Link to="/about">About</Link>
          <Link to="/contactus">Contact Us</Link>
          <Link to="/login">Client Login</Link>
        </nav>

        <div className="footer-col">
          <span className="footer-col-title">Reach us</span>
          <a href="mailto:info@celsius.in">info@celsius.in</a>
          <a href="tel:+919650012315">+91 96500 12315</a>
          <span className="footer-address">
            E199, EPIP, RIICO Industrial Area, Neemrana, Rajasthan 301705
          </span>
        </div>
      </div>

      <div className="footer-bottom">
        <span>© Celsius, {year}. All rights reserved.</span>
      </div>
    </footer>
  );
}

export default Footer;
